
import { api } from "../../utils/api";

export const getParcelDescription = async () => {
  const response = await api.get(`installment-desc`);
  const data = response.data.map((dado) => ({
    id: dado.id,
    description: dado.name,
  }));
  return data;
};